export const employ = [
   {
      id: 1,
      img: "4.jpg",
      name: "John Deo",
      online: "(14+ Online)",
      designation: "Designer",
      width: "30%",
      year: "2 year",
      color:"primary"

   },
   {
      id: 2,
      img: "1.jpg",
      name: "Holio Mako",
      online: "(250+ Online)",
      designation: "Developer",
      width: "70%",
      year: "3 Year",
      color:"secondary"
   },
   {
      id: 3,
      img: "5.jpg",
      name: "Mohsib lara",
      online: "(99+ Online)",
      designation: "Tester",
      width: "60%",
      year: "5 Month",
      color:"primary"

   },
   {
      id: 4,
      img: "6.jpg",
      name: "Hileri Soli",
      online: "(150+ Online)",
      designation: "Designer",
      width: "30%",
      year: "3 Month",
      color:"secondary"
   },
   {
      id: 5,
      img: "7.jpg",
      name: "Pusiz bia",
      online: "(14+ Online)",
      designation: "Designer",
      width: "90%",
      year: "5 Year",
      color:"primary"
   },

]